<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col>
        <component-header
          title="Coupon Code"
          :isLoading="loading"
          @relaod-data="getCouponCodeList"
          @create-press="$router.push({ name: 'Createcoupon' })"
          :hasSearch="false"
          :hasClear="false"
        />
      </b-col>
    </b-row>
    <b-card class="card-wrap mt-2" border-variant="info">
      <b-row class="mt-3">
        <b-col md="3" class="my-1">
          <b-form-group label-cols-sm="3" class="mb-0">
            <eb-input
              lable="Coupon Code"
              id="couponCode"
              placeholder="Coupon Code"
              v-model="filterCouponCode"
              type="text"
            ></eb-input>
          </b-form-group>
        </b-col>
        <b-col md="3" class="my-1">
          <b-form-group label-cols-sm="3" class="mb-0">
            <label>Time Period</label>
            <eb-select
              type="select"
              v-model="selectedPeriod"
              :options="periodList"
              label="text"
              :id="'selecttime'"
              @input="changePeriod"
              :selected="selectedPeriod"
            ></eb-select>
          </b-form-group>
        </b-col>
        <b-col md="3" class="my-1">
          <b-form-group label-cols-sm="3" class="mb-0">
            <label>Select Provider</label>
            <eb-select
              type="select"
              v-model="selectedProvider"
              :options="partnerList"
              label="partnerName"
              id="selectprovider"
              :selected="selectedProvider"
              placeholder="Select Provider"
              @input="changeProvider"
            ></eb-select>
          </b-form-group>
        </b-col>
        <b-col md="3" class="my-1">
          <b-form-group label-cols-sm="3" class="mb-0">
            <label>Status</label>
            <eb-select
              type="select"
              v-model="selectedStatus"
              :options="['ALL', 'PENDING APPROVAL', 'APPROVED']"
              :id="'selectprovider'"
              :selected="selectedStatus"
              placeholder="Select Status"
              @input="changeProvider"
            ></eb-select>
          </b-form-group>
        </b-col>
      </b-row>
      <div class="mt-2">
        <b-table
          :dark="dark"
          :hover="hover"
          :striped="striped"
          :bordered="bordered"
          :small="small"
          :fixed="fixed"
          responsive
          id="my-table"
          :filter="filterCouponCode"
          :current-page="currentPage"
          :per-page="perPage"
          :items="couponcodeList"
          thead-class="header"
          class="mt-3"
          :fields="Columns"
          show-empty
          @filtered="onFilter"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
        >
          <template slot="action" slot-scope="data">
            <b-button
              size="sm"
              class="mr-2 button-circle"
              variant="primary"
              @click="navigateTo(data.item, 'view')"
            >
              <i class="fa fa-eye"></i>
            </b-button>
            <b-button
              size="sm"
              class="mr-2 button-circle"
              style="background: #fe7b08; border: #fe7b08;"
              variant="primary"
              @click="navigateTo(data.item, 'edit')"
            >
              <i class="fa fa-pencil edit"></i>
            </b-button>
            <b-button
              size="sm"
              class="mr-2 button-circle"
              variant="danger"
              @click="deleteCouponcode(data)"
            >
              <i class="fa fa-trash bin"></i>
            </b-button>
            <template v-if="$userRole === 'Tenant'">
              <b-button
                size="sm"
                class="mr-2 button-circle"
                variant="primary"
                v-if="
                  !data.item.isApproved &&
                  time()(data.item.time.startDate).isSameOrBefore() &&
                  time()(data.item.time.endDate).isSameOrAfter()
                "
                @click="ApproveCoupon(data.item)"
              >
                <i class="fa fa-check"></i>
              </b-button>
            </template>
          </template>
          <template v-slot:empty="scope">
            <h4>{{ scope.emptyText }}</h4>
          </template>
        </b-table>
      </div>
      <div style="float: right" v-if="couponcode.length > perPage">
        <b-pagination
          v-model="currentPage"
          :per-page="perPage"
          :total-rows="filterCount"
          aria-controls="my-table"
          prev-text="Prev"
          next-text="Next"
          hide-goto-end-buttons
        ></b-pagination>
      </div>
      <!-- <p v-else style="text-align:center;padding-top:10px;">No data available!</p> -->
    </b-card>
  </div>
</template>
<script>
import ebButton from "@/components/FormElements/Button";
import loader from "@/components/loader/nipigeloader.vue";
import Createcoupon from "@/components/MasterSetup/Coupon/Createcoupon";
import Editcoupon from "@/components/MasterSetup/Coupon/Editcoupon";
import Viewcoupon from "@/components/MasterSetup/Coupon/ViewCoupon";
import moment from "moment";
import { mapGetters, mapActions } from "vuex";
import ebSelect from "@/components/FormElements/Select";
import ebInput from "@/components/FormElements/Input";
import ComponentHeader from "@/components/componentNewHeader";
export default {
  name: "Coupondetails",
  components: {
    ebButton,
    loader,
    Createcoupon,
    Editcoupon,
    Viewcoupon,
    ebSelect,
    ebInput,
    ComponentHeader,
  },
  data() {
    return {
      loading: false,
      perPage: 10,
      hover: true,
      striped: false,
      bordered: true,
      small: false,
      dark: false,
      fixed: false,
      currentPage: 1,
      context: "Add",
      faqModal: false,
      header: "Edit Faq",
      couponCodeList: {},
      couponData: {},
      filterCount: 0,
      selectedStatus: "ALL",
      selectedProvider: { partnerName: "ALL", _id: "" },
      filterCouponCode: "",
      sortBy: "createdAt",
      sortDesc: true,
      Columns: [
        {
          key: "CouponCode",
          label: "CouponCode",
          sortable: true,
        },
        {
          key: "Coupon value",
        },
        {
          key: "Start Date",
        },
        {
          key: "End Date",
        },
        {
          key: "action",
        },
      ],
      selectedPeriod: {
        text: "Last 7 days",
        value: 7,
      },
      periodList: [
        {
          text: "Last 7 days",
          value: 7,
        },
        {
          text: "Last 15 days",
          value: 15,
        },
        {
          text: "Last 30 days",
          value: 30,
        },
        {
          text: "Last 3 Months",
          value: 90,
        },
        {
          text: "Last 6 Months",
          value: 180,
        },
      ],
    };
  },
  computed: {
    ...mapGetters({
      couponcode: "coupon/couponCodeList",
    }),
    couponcodeList() {
      this.loading = true;
      let couponListData = [];
      if (Array.isArray(this.couponcode) && this.couponcode.length > 0) {
        this.couponcode
          .filter((x) => !x.isDeleted)
          .forEach((data, i) => {
            const object = {
              index: i,
              _id: data._id,
              CouponCode: data.promoCode.toUpperCase(),
              "Coupon value": data.promoRules.rewardValue,
              "Start Date": moment(data.promoRules.startDate).format(
                "DD/MM/yyyy"
              ),
              "End Date": moment(data.promoRules.endDate).format("DD/MM/yyyy"),
              isApproved: data.isApproved,
              time: {
                startDate: data.promoRules.startDate,
                endDate: data.promoRules.endDate,
              },
            };
            couponListData.push(object);
          });
      }
      return couponListData;
    },
    partnerList() {
      let data = this.$store.getters["partner/GetPartnerLiteList"];
      if (data.length > 0) {
        let partners = [
          {
            partnerName: "ALL",
            _id: "",
          },
        ];
        data.map((obj) => {
          partners.push({ ...obj, partnerName: obj.organization.name });
        });
        return partners;
      }
    },
  },
  methods: {
    ...mapActions({
      GetPartnerList: "partner/fetchPartnerListLite",
    }),
    changeProvider() {
      this.getCouponCodeList();
    },
    changePeriod(event) {
      this.getCouponCodeList();
    },
    navigateTo(data, type) {
      this.couponData = this.couponcode.find((x) => x._id === data._id);
      if (type === "edit") {
        this.$router.push({
          name: "Editcoupon",
          params: { data: this.couponData },
        });
        return;
      }
      if (type === "view") {
        this.$router.push({
          name: "ViewCoupon",
          params: { data: this.couponData },
        });
        return;
      }
    },
    async ApproveCoupon(coupon) {
      this.$swal({
        title: "Warning",
        text: "Are you sure? You want to Approve?",
        type: "warning",
        confirmButtonText: "Yes",
        showCancelButton: true,
      }).then((result) => {
        if (result.value) {
          const data = { promoCode: coupon.CouponCode };
          try {
            this.$store.dispatch("coupon/approveCouponcode", data);
            this.$swal({
              title: "Success",
              text: "Coupon approved successfully!!",
              type: "success",
            });
            this.getCouponCodeList();
          } catch (e) {
            this.$swal({
              title: "Error",
              text: "Error occured while approving coupon",
              type: "error",
            });
          }
        }
      });
    },

    deleteCouponcode(couponcode) {
      this.$swal({
        title: "Delete this coupon?",
        text: "Are you sure? You won't be able to revert this!",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        confirmButtonText: "Yes, Delete it!",
      }).then((result) => {
        if (result.value) {
          this.$store
            .dispatch("coupon/deleteCouponcode", {
              promoCode: couponcode.item.CouponCode,
            })
            .then((result) => {
              this.$toasted.success("coupon Deleted Successfully");
              this.getCouponCodeList();
              this.loading = true;
            })
            .catch((err) => {
              // delete failed
            });
        }
      });
    },
    async getCouponCodeList() {
      this.loading = true;
      const payload = {
        n: this.selectedPeriod.value,
      };
      if (this.$userRole === "Tenant") {
        if (this.selectedProvider && this.selectedProvider._id) {
          payload.providerId = this.selectedProvider._id;
        }
      } else {
        payload.providerId = this.$currentUserData._id;
      }
      if (this.selectedStatus !== "ALL") {
        payload.status = this.selectedStatus === "APPROVED";
      }
      try {
        await this.$store.dispatch("coupon/promotionListByFilter", payload);
        this.loading = false;
      } catch (e) {
        this.loading = false;
      }
    },
    time() {
      return moment;
    },
    onFilter(list) {
      this.filterCount = list.length;
      this.currentPage = 1;
    },
  },
  mounted() {
    this.getCouponCodeList();
    this.GetPartnerList({ type: "SELLER" });
  },
};
</script>
<style lang="sass" scoped>
.edit
  color: white !important
.text-center
  text-align: center
.form-div label
  margin-top: 8px
</style>
